// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.spinner,.spinner svg{transform-origin:center center}.spinner{color:currentColor;font-size:2.25rem;left:50%;line-height:1;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:2}.spinner.z-2above{z-index:3}.spinner.z-3above{z-index:4}.spinner.z-4above{z-index:5}.spinner svg{animation:spin 1s linear infinite forwards;transform:rotate(0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
